import Calendar from "components/common/Calendar";
import { motion } from "framer-motion";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import moment from "moment"; // Recommended: use moment instead of manual parsing

const PreauthProviderServices = () => {
  const { viewPreauthorizationInfo } = useSelector(
    (state) => state.preauthorization
  );

  const preauthServices =
    viewPreauthorizationInfo?.provider_request?.service_procedures || [];
  const diagnosis = viewPreauthorizationInfo?.provider_request?.diagnosis || [];

  // Helper to safely format date from YYYY-MM-DD
  const formatServiceDate = (dateStr) => {
    if (!dateStr || !/^\d{4}-\d{2}-\d{2}$/.test(dateStr))
      return { day: "", month: "", year: "" };

    const date = moment(dateStr, "YYYY-MM-DD");
    if (!date.isValid()) return { day: "", month: "", year: "" };

    console.log({ date: date.format("DD") });

    return {
      day: date.format("DD"),
      month: date.format("MMM"),
      year: date.format("YYYY"),
    };
  };

  return (
    <motion.div
      style={{ border: "2px solid #d9f8eb" }}
      className="rounded p-3 position-relative mt-3 mb-3"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      transition={{ duration: 0.5 }}
    >
      <div className="position-absolute top-0 start-45 translate-middle-y px-2">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-10">Service & Procedures</span>
        </span>
      </div>

      <Row className="mt-4">
        {preauthServices.map((item, index) => {
          const dosageInstructionInfo =
            item?.medication_request?.dosage_instruction;
          const grossAmt =
            Number(item?.servinfo_prdpri) * Number(item?.servinfo_prdqty);

          const discountAmt = Number(item?.servinfo_prddisc / 100) * grossAmt;

          const diagInfo = diagnosis.find(
            (d) => d?.diagonis_code === item?.servinfo_diag
          );
          const { day, month, year } = formatServiceDate(item.dateserv);

          console.log({ day, month, year });

          const hasPrescriptionDetails = Boolean(
            item.presmed ||
              item.pharslrsn ||
              item.pharsubs ||
              item.pharstrnth ||
              item.pharscabrsn ||
              item?.absenceRsn ||
              item?.pharscabrsn_oth ||
              (dosageInstructionInfo?.period_start &&
                dosageInstructionInfo?.period_end) ||
              dosageInstructionInfo?.duration ||
              dosageInstructionInfo?.frequency ||
              dosageInstructionInfo?.dose ||
              dosageInstructionInfo?.dosage_instruction ||
              dosageInstructionInfo?.refill ||
              dosageInstructionInfo?.patient_instruction ||
              dosageInstructionInfo?.time_instruction_desc ||
              dosageInstructionInfo?.route_desc
          );

          return (
            <Col
              xs={12}
              key={`${item.itemcode}-${item.dateserv}-${index}`}
              className="mb-3"
            >
              <Card className="p-3 h-100 shadow-sm">
                <Row className="g-3">
                  <Col xs={12} md={2} className="text-center">
                    <div className="badge badge-subtle-success fs-10 mb-3">
                      {index + 1}
                    </div>
                    {item.dateserv && (
                      <div className="d-flex justify-content-center mt-2">
                        <Calendar month={month} day={day} year={year} />
                      </div>
                    )}
                  </Col>

                  <Col xs={12} md={10}>
                    <Row>
                      {/* Service Code & Description */}
                      <Col xs={12} className="mb-3">
                        <div className="d-flex flex-wrap gap-3 align-items-center">
                          <div>
                            <span className="badge badge-subtle-success me-2">
                              {item.itemcode}
                            </span>
                            <span className="fs-10 text-700">
                              {item.itemdescp || item.nphiesDescription}
                            </span>
                          </div>
                          {item.itemlclcode && (
                            <div>
                              <span className="badge badge-subtle-warning me-2">
                                {item.itemlclcode}
                              </span>
                              <span className="fs-10 text-muted">
                                {item.itemlcldescp || item.internalDescription}
                              </span>
                            </div>
                          )}
                        </div>
                      </Col>

                      {/* Main Info Grid */}
                      <Col xs={12}>
                        <Row className="gy-2">
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 fw-semibold">Type</span>
                              <span className="fs-10 text-600">
                                {item.prdtyp}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Unit Price
                              </span>
                              <span className="fs-10">
                                {item.servinfo_prdpri}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Discount Amount
                              </span>
                              <span className="fs-10  ">{discountAmt}</span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Quantity
                              </span>
                              <span className="fs-10 text-600">
                                {item.servinfo_prdqty}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Patient Share
                              </span>
                              <span className="fs-10 text-600 ">
                                {item.servinfo_prdpshre}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Net Amount
                              </span>
                              <span className="fs-10  ">
                                {item.servinfo_prdnamnt}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Tooth No
                              </span>
                              <span className="fs-10 fw-bold ">
                                {item.toothno}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Diagnosis
                              </span>
                              <span className="fs-10 text-600">
                                {diagInfo?.diagonis_code
                                  ? `(${diagInfo?.diagonis_code}) - ${diagInfo?.diagonis_description}`
                                  : diagInfo?.diagonis_description}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Practitioner
                              </span>
                              <span className="fs-10 text-600">
                                {item.pract_name}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Is Maternity
                              </span>
                              <span className="fs-10 text-600">
                                {item.matrnty}
                              </span>
                            </div>
                          </Col>
                          {item.bodysite && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-800 fw-bold">
                                  Body Site
                                </span>
                                <span className="fs-10 text-600">
                                  {item.bodysitedesc}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item.subsite && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-800 fw-bold">
                                  Sub Site
                                </span>
                                <span className="fs-10 text-600">
                                  {item.subsitedesc}
                                </span>
                              </div>
                            </Col>
                          )}
                          {hasPrescriptionDetails && (
                            <div className="fs-9 text-success fw-bold mb-2 border-bottom py-2">
                              Prescription Details
                            </div>
                          )}
                          {item.presmed && (
                            <Col xs={6} md={2}>
                              <div className="d-flex  flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Prescribed Medication Code
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {item.presmed}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item.claimMedicalDisplay && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Prescribed Medication Desc.
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {item.claimMedicalDisplay}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item.pharstrnth && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Strength
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {item.pharstrnth}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item.pharscabrsn && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Absence Reason
                                </span>
                                <span className="fs-10 text-capitalize text-info-emphasis">
                                  {item.pharscabrsn}
                                  {item?.pharscabrsn_oth && (
                                    <div>({item?.pharscabrsn_oth})</div>
                                  )}
                                </span>
                              </div>
                            </Col>
                          )}

                          {item.pharslrsn && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Selection Reason
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {item.pharslrsn}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item.pharsubs && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Pharmacist Substitute
                                </span>
                                <div className="d-flex flex-column">
                                  <span className="fs-10 text-info-emphasis">
                                    {item.pharsubs}
                                  </span>
                                  {item.pharscabrsn &&
                                    item.pharscabrsn != "-" && (
                                      <span className="fs-10 text-info-emphasis">
                                        ({item.pharscabrsn})
                                      </span>
                                    )}
                                </div>
                              </div>
                            </Col>
                          )}

                          {dosageInstructionInfo?.period_start &&
                            dosageInstructionInfo?.period_end && (
                              <Col xs={6} md={2}>
                                <div className="d-flex flex-column">
                                  <span className="fs-10 text-info fw-bold">
                                    Period
                                  </span>
                                  <span className="fs-10 text-info-emphasis">
                                    {`${dosageInstructionInfo?.period_start} - ${dosageInstructionInfo?.period_end}`}
                                  </span>
                                </div>
                              </Col>
                            )}
                          {dosageInstructionInfo?.duration && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Duration
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {dosageInstructionInfo?.duration}
                                </span>
                              </div>
                            </Col>
                          )}
                          {dosageInstructionInfo?.frequency && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Frequency
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {dosageInstructionInfo?.frequency}
                                </span>
                              </div>
                            </Col>
                          )}
                          {dosageInstructionInfo?.dose && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Dose
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {`${dosageInstructionInfo?.dose}`}
                                </span>
                              </div>
                            </Col>
                          )}
                          {dosageInstructionInfo?.route_desc && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Route
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {dosageInstructionInfo?.route_desc}
                                </span>
                              </div>
                            </Col>
                          )}
                          {dosageInstructionInfo?.time_instruction_desc && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Time Instruction
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {dosageInstructionInfo?.time_instruction_desc}
                                </span>
                              </div>
                            </Col>
                          )}
                          {dosageInstructionInfo?.refill && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Refill
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {dosageInstructionInfo?.refill}
                                </span>
                              </div>
                            </Col>
                          )}
                          {dosageInstructionInfo?.text && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Dosage Instruction
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {dosageInstructionInfo?.text}
                                </span>
                              </div>
                            </Col>
                          )}
                          {dosageInstructionInfo?.patient_instruction && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Patient Instruction
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {dosageInstructionInfo?.patient_instruction}
                                </span>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card>
            </Col>
          );
        })}

        {/* Totals Card */}
        {preauthServices.length > 0 && (
          <Col xs={12} className="mt-3">
            <Card className="p-3">
              <Row className="text-center text-md-start">
                <Col xs={12} md={4}>
                  <div className="fw-bold fs-10 text-800 mb-2">
                    Total Net Amount
                  </div>
                  <div className="fs-10 text-primary fw-bold">
                    {preauthServices
                      .reduce(
                        (sum, s) => sum + parseFloat(s.servinfo_prdnamnt || 0),
                        0
                      )
                      .toFixed(2)}{" "}
                    SAR
                  </div>
                </Col>
                <Col xs={12} md={4}>
                  <div className="fw-bold fs-10 text-800 mb-2">
                    Total Patient Share
                  </div>
                  <div className="fs-10 text-primary fw-bold">
                    {preauthServices
                      .reduce(
                        (sum, s) => sum + parseFloat(s.servinfo_prdpshre || 0),
                        0
                      )
                      .toFixed(2)}{" "}
                    SAR
                  </div>
                </Col>
                <Col xs={12} md={4}>
                  <div className="fw-bold fs-10 text-800 mb-2">Total VAT</div>
                  <div className="fs-10 text-success fw-bold">
                    {preauthServices
                      .reduce(
                        (sum, s) =>
                          sum + parseFloat(s.servinfo_prdnamnt || 0) * 0.15,
                        0
                      )
                      .toFixed(2)}{" "}
                    SAR
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        )}
      </Row>
    </motion.div>
  );
};

export default PreauthProviderServices;
